// client/src/coms/views/canvas_parts/CanvasTextSettingsPanel.js
import React from 'react';

export const CANVAS_TEXT_FONTS = [
  'Arial', 'Arial Black', 'Arial Narrow', 'Arial Rounded MT Bold', 'Bahnschrift',
  'Book Antiqua', 'Bookman Old Style', 'Bradley Hand', 'Brush Script MT', 'Calibri',
  'Cambria', 'Candara', 'Century', 'Century Gothic', 'Charter',
  'Comic Sans MS', 'Consolas', 'Cooper Black', 'Courier New', 'Didot',
  'Franklin Gothic Medium', 'Futura', 'Garamond', 'Geneva', 'Georgia',
  'Gill Sans', 'Helvetica', 'Helvetica Neue', 'Impact', 'Lucida Console',
  'Lucida Sans Unicode', 'Marker Felt', 'Menlo', 'Monaco', 'Montserrat',
  'Noto Sans', 'Noto Serif', 'Optima', 'Palatino', 'Papyrus',
  'Perpetua', 'Rockwell', 'Segoe Print', 'Segoe Script', 'Segoe UI',
  'Tahoma', 'Times New Roman', 'Trebuchet MS', 'Verdana', 'Yu Gothic',
];

const controlStyle = {
  width: '100%',
  boxSizing: 'border-box',
  border: '1px solid rgba(255,255,255,0.16)',
  borderRadius: 5,
  background: 'rgba(0,0,0,0.22)',
  color: '#fff',
  padding: '7px 8px',
  fontSize: 13,
};

export default function CanvasTextSettingsPanel({ textSettings, setTextSettings }) {
  const settings = textSettings || {};
  const update = (patch) => {
    if (typeof setTextSettings === 'function') setTextSettings({ ...settings, ...patch });
  };
  const toggleStyle = (key) => update({ [key]: !settings[key] });
  const buttonStyle = (active, extra = {}) => ({
    ...controlStyle,
    cursor: 'pointer',
    background: active ? 'rgba(65,126,190,0.9)' : controlStyle.background,
    ...extra,
  });

  return (
    <section style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
      <div style={{ color: '#fff', fontWeight: 900, fontSize: 13 }}>Text Properties</div>

      <label style={{ display: 'flex', flexDirection: 'column', gap: 5, color: 'rgba(255,255,255,0.86)', fontSize: 12, fontWeight: 800 }}>
        Font family
        <select
          value={settings.fontFamily || 'Arial'}
          onChange={(event) => update({ fontFamily: event.target.value })}
          style={{ ...controlStyle, fontFamily: settings.fontFamily || 'Arial' }}
        >
          {CANVAS_TEXT_FONTS.map((font) => (
            <option key={font} value={font} style={{ fontFamily: font, color: '#000' }}>{font}</option>
          ))}
        </select>
      </label>

      <div style={{ display: 'grid', gridTemplateColumns: '1fr 92px', gap: 8 }}>
        <label style={{ display: 'flex', flexDirection: 'column', gap: 5, color: 'rgba(255,255,255,0.86)', fontSize: 12, fontWeight: 800 }}>
          Size
          <input
            type="number"
            min="6"
            max="400"
            step="1"
            value={Number(settings.fontSize) || 48}
            onChange={(event) => update({ fontSize: Math.max(6, Math.min(400, Number(event.target.value) || 48)) })}
            style={controlStyle}
          />
        </label>
        <label style={{ display: 'flex', flexDirection: 'column', gap: 5, color: 'rgba(255,255,255,0.86)', fontSize: 12, fontWeight: 800 }}>
          Spacing
          <input
            type="number"
            min="-20"
            max="100"
            step="0.5"
            value={Number(settings.letterSpacing) || 0}
            onChange={(event) => update({ letterSpacing: Number(event.target.value) || 0 })}
            style={controlStyle}
          />
        </label>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 7 }}>
        <button type="button" title="Bold" onClick={() => toggleStyle('bold')} style={buttonStyle(settings.bold, { fontWeight: 900 })}>B</button>
        <button type="button" title="Italic" onClick={() => toggleStyle('italic')} style={buttonStyle(settings.italic, { fontStyle: 'italic' })}>I</button>
        <button type="button" title="Underline" onClick={() => toggleStyle('underline')} style={buttonStyle(settings.underline, { textDecoration: 'underline' })}>U</button>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 7 }}>
        <button type="button" onClick={() => update({ align: 'left' })} style={buttonStyle((settings.align || 'left') === 'left')}>Left</button>
        <button type="button" onClick={() => update({ align: 'center' })} style={buttonStyle(settings.align === 'center')}>Centre</button>
        <button type="button" onClick={() => update({ align: 'right' })} style={buttonStyle(settings.align === 'right')}>Right</button>
      </div>

      <label style={{ display: 'flex', flexDirection: 'column', gap: 5, color: 'rgba(255,255,255,0.86)', fontSize: 12, fontWeight: 800 }}>
        Line height: {Math.round((Number(settings.lineHeight) || 1.2) * 100)}%
        <input type="range" min="0.8" max="3" step="0.05" value={Number(settings.lineHeight) || 1.2} onChange={(event) => update({ lineHeight: Number(event.target.value) })} />
      </label>

      <div style={{ borderTop: '1px solid rgba(255,255,255,0.12)', paddingTop: 9, color: 'rgba(255,255,255,0.66)', fontSize: 11, lineHeight: 1.45 }}>
        Click text to select and transform it. Double-click text to edit it. Click empty canvas once to deselect; click empty canvas again to create “Placeholder Text”. Ctrl/Cmd + Enter finishes editing.
      </div>
    </section>
  );
}
